<div class="customer-detail ml20">
  <div class="row">
    <div class="col-md-4 col-lg-4 col-sm-4 padding-l">
      <div class="section-container">
        {{ "orderCheckOut.endCstmrAdd" | cxTranslate }}
        <span class="selected" *ngIf="selectedAddress && !cart?.quoteCartType">
          <span class="sel">{{ "orderCheckOut.selected" | cxTranslate }}</span>
        </span>
        <span *ngIf="!selectedAddress && !cart?.quoteCartType" #endCustomerAddressNotSelectedError>
        </span>
      </div>
      <address>
        <div>
          {{ selectedAddress?.firstName }} {{ selectedAddress?.lastName }}
        </div>
        <div>{{ selectedAddress?.companyName }}</div>
        <div>
          {{ selectedAddress?.line1 }}{{ selectedAddress?.line1 ? "," : " " }}
          {{ selectedAddress?.line2 }}{{ selectedAddress?.line2 ? "," : " " }}
        </div>
        <div>
          {{ selectedAddress?.town }}{{ selectedAddress?.town ? "," : " " }}
        </div>
        <div>
          {{ selectedAddress?.region?.name
          }}{{ selectedAddress?.region?.name ? "," : " " }}
        </div>
        <div>
          {{ selectedAddress?.country?.name
          }}{{ selectedAddress?.country?.name ? "," : " " }}
          {{ selectedAddress?.postalCode }}
        </div>
      </address>

      <div class="ter-btn-holder mt-3" *ngIf="!isSelectAddress && hideBtn">
        <button
          class="vs-tertiary-btn"
          (click)="isSelectAddress = !isSelectAddress"
        >
          {{ "orderCheckOut.selectAddress" | cxTranslate }}
        </button>
      </div>
    </div>

    <div class="col-md-8 col-lg-8 col-sm-8 fl_right">
      <vs-address
        *ngIf="isSelectAddress"
        (reciveEndUserAddress)="selectedAdd($event)"
        (closeEndAdd)="closeForm($event)"
        [isCommissionEligible]='customerDetailsObj?.isCommissionEligible'
        [componentAddress]="componentAddress"
        [soldToAddress]="cart?.billToAddress"
        [cartName]="cartName"
      ></vs-address>
    </div>
  </div>

  <div class="row">
    <form [formGroup]="myGroupEnd" *ngIf="myGroupEnd">
      <div class="order-type">
        <div>
          <label
            ><span class="star"></span>
            {{ "orderCheckOut.endUseIndustry" | cxTranslate }}</label
          >

          <ng-select
            [clearable]='false'
            [searchable]='true'
            placeholder='{{ "orderCheckOut.selectPlaceholder" | cxTranslate }}'
            appendTo='body'
            class="customer-reference order-checkout-text"
            [ngClass]="
              isProceedToCheckout &&
              formControls.endUseIndustry.invalid
                ? 'error-select'
                : ''
            "
            formControlName="endUseIndustry"
            (change)="onEndUserSelect($event)"
          >


            <ng-option
              *ngFor="let endUser of getEndUserArray"
              [value]="endUser.code"
            >
              {{ endUser?.value }}
            </ng-option>

          </ng-select>

          <label #endUseIndustryError
            class="error"
            *ngIf="
              isProceedToCheckout &&
              formControls.endUseIndustry.invalid
            "
          >
            {{ "orderCheckOut.endUseIndustryError" | cxTranslate }}
          </label>
        </div>
      </div>
    </form>
  </div>
</div>
